import React, {  Component } from 'react';

export default class ShippingMethodDescriptionsOverlayDialog extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showDialog: false
        }
    }

    closeDialog(event) {
        event.preventDefault();
        this.setState({
            showDialog: false
        });
		this.props.handleDialog && this.props.handleDialog('ShippingMethodDescriptionsOverlayDialog', false);
    }

    componentDidMount() {
		// window.scrollTo(0, 0);
        this.setState({
            showDialog: this.props.showDialog
        });
    }

    render() {
        return (
            <div className={"overlayDialog "+(this.state.showDialog?"visible":"hide")} id="orderStatusDescriptionsOverlayDialog">
                <div className="blackoutLayer"></div>
                <div className="overlayDialogWindow">
                    <a className="closeButton" onClick={this.closeDialog.bind(this)}>×</a>
                    <h2 className="title">Shipping Method Descriptions</h2>
					<table className="dataTable orderStatusDescriptionsTable">
						<thead>
							<tr>
								<th>Status</th>
								<th>Status Description</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>SDS&nbsp;DELIVERY</td>
								<td>Shipment less than 26 points delivered by a Scheduled Delivery Service (SDS) agent</td>
							</tr>
							<tr>
								<td>WILL&nbsp;CALL</td>
								<td>Shipment picked up at the SDS warehouse or ADC</td>
							</tr>
							<tr>
								<td>ADC&nbsp;TRUCKLOAD</td>
								<td>Shipment 26-126 points shipped direct from a serving ADC as tailgate delivery</td>
							</tr>
                            <tr>
								<td>ADC&nbsp;LTL</td>
								<td>Less-than-truckload shipment outside of a SDS-served area shipped via common carrier</td>
							</tr>
						</tbody>
					</table>
				</div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/App/components/dialogs/shippingMethodDescriptionsOverlayDialog.js